export class Coordinate {
    public latitude: number;
    public longitude: number;
    public static spatialSearchFromCoordinates(southWest: Coordinate, northEast: Coordinate): string {
        return `[${southWest.toString()} TO ${northEast.toString()}]`;
    }

    public static coordinateFromString(coordinate: string): Coordinate | null {
        const coordinateParts: string[] = coordinate?.split(',') ?? [];

        if (coordinateParts.length < 2) {
            console.error(`Coordinate is in wrong format: ${coordinate}`);
            return null;
        }
        try {
            const coordinate: Coordinate = new Coordinate(
                Number.parseFloat(coordinateParts[0]),
                Number.parseFloat(coordinateParts[1])
            );
            return coordinate;
        } catch (e) {
            console.error(`Coordinate is in wrong format: ${coordinate}`, e);
            return null;
        }
    }

    constructor(latitude: number, longitude: number) {
        this.latitude = this.checkLatitude(latitude);
        this.longitude = this.checkLongitude(longitude);
    }

    private checkLatitude(latitude: number): number {
        if (latitude > 90) {
            console.warn(`Coordinate:: Provided latitude ${latitude} out of bounds`);
            return 90;
        }

        if (latitude < -90) {
            console.warn(`Coordinate:: Provided latitude ${latitude} out of bounds`);
            return -90;
        }
        return latitude;
    }

    private checkLongitude(longitude: number): number {
        if (longitude > 180) {
            console.warn(`Coordinate:: Provided longitude ${longitude} out of bounds`);
            return 180;
        }

        if (longitude < -180) {
            console.warn(`Coordinate:: Provided longitude ${longitude} out of bounds`);
            return -180;
        }
        return longitude;
    }

    public toString(): string {
        return `${this.latitude},${this.longitude}`;
    }

    public toLatLing(): google.maps.LatLngLiteral {
        return {
            lat: this.latitude,
            lng: this.longitude
        };
    }

    public toSpacialSearch(): string {
        const LOCAL_SEARCH_OFFSET = 0.001;

        const southWest: Coordinate = new Coordinate(
            this.latitude - LOCAL_SEARCH_OFFSET,
            this.longitude - LOCAL_SEARCH_OFFSET
        );

        const northEast: Coordinate = new Coordinate(
            this.latitude + LOCAL_SEARCH_OFFSET,
            this.longitude + LOCAL_SEARCH_OFFSET
        );

        return Coordinate.spatialSearchFromCoordinates(southWest, northEast);
    }
}
